import React from 'react';
import PropTypes from 'prop-types';
import { List, ListItem, ListItemAvatar, ListItemText, Avatar } from '@material-ui/core';
import FileAttachment from '@material-ui/icons/Attachment';
import config from '../../config/index';

const Attachments = ({ attachments, unit }) => {
  return (
    <div className="row">
      <div className="box-header-outside">
        <div className="col-sm-12">
          <div className="header">
            <h2>Do pobrania</h2>
          </div>
        </div>
      </div>
      <div className="box">
        <div className="col-sm-12">
          <List dense={true}>
            {attachments.map((attachment, index) => (
              <ListItem button key={index} onClick={() => window.open(`${config.getBlobUrl(unit.url)}${attachment.id.replace(/-/g, '')}`, '_blank')}>
                <ListItemAvatar>
                  <Avatar>
                    <FileAttachment />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={attachment.fileName}
                />
              </ListItem>
            ))}
          </List>
        </div>
      </div>
    </div>
  );
};

Attachments.propTypes = {
  attachments: PropTypes.array.isRequired,
  unit: PropTypes.object.isRequired,
};

export default Attachments;


// WEBPACK FOOTER //
// ./src/components/budget/Attachments.js